import { useQuery } from '@tanstack/vue-query'
import { useConfiguratorApi } from '@/composables/api/useConfiguratorApi'
import type { DispatchMetadata } from 'shared/src'
import { computed, type MaybeRef, toValue } from 'vue'

export const configurationDataQueryKey = (id: string) => ['configurations', 'data', id] as const

export function useConfigurationDataQuery(id: MaybeRef<string | null | undefined>) {
  const { getConfigurationData } = useConfiguratorApi()

  return useQuery<DispatchMetadata | null>({
    queryKey: computed(() => configurationDataQueryKey(toValue(id) ?? '')),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => getConfigurationData(toValue(id)!),
    enabled: computed(() => !!toValue(id)),
  })
}
